module.exports = __webpack_public_path__ + "img/icons-room-add.bd36e26.svg";